/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifactpackeyebrow2Inputs */

const en_artifactpackeyebrow2 = /** @type {(inputs: Artifactpackeyebrow2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Most homeowners pick this`)
};

const pt_artifactpackeyebrow2 = /** @type {(inputs: Artifactpackeyebrow2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A escolha da maioria`)
};

/**
* | output |
* | --- |
* | "Most homeowners pick this" |
*
* @param {Artifactpackeyebrow2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const artifactpackeyebrow2 = /** @type {((inputs?: Artifactpackeyebrow2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifactpackeyebrow2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_artifactpackeyebrow2(inputs)
	return pt_artifactpackeyebrow2(inputs)
});
export { artifactpackeyebrow2 as "artifactPackEyebrow" }